<template>
  <div>
    <HeroSmall />
    <b-container class="mt-5 mb-5">
      <h1 class="display-1">Jobs</h1>
    </b-container>
  </div>
</template>

<script>
import HeroSmall from '@/components/ui/HeroSmall.vue'
export default {
  name: 'Jobs',
  components: {
    HeroSmall,
  }
}
</script>

<style scoped>

</style>